import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import Form from "../../../form/Form";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import { taxonomyAddEdit, taxonomyDetails, taxonomyList } from "../../../../services/taxonomyService";
import Button from "../../../form/Button";
import FlexibleSelect from "../../../form/select/FlexibleSelect";
import LanguageTabs from "../../../elements/LanguageSwitcher";
import { supportedLanguages, userLang } from "../../../../helpers";

const TagManage = ({ open, close = () => {}, getResponse = () => {}, data = {}, type }) => {
  
  const validation = {
    title: { required: true, message: "Title is required" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
    initialState:{status:"active"}
  });

  const [currentLang, setCurrentLang] = useState(userLang);

  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["tag-details", data?._id],
    queryFn: async () => {
      const res = await taxonomyDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        ...details,
        content: {
          ...supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = {
              title: details?.content?.[lang.code]?.title || "",
              subTitle: details?.content?.[lang.code]?.subTitle || "",
              content: details?.content?.[lang.code]?.content || "",
              seo: details?.content?.[lang.code]?.seo || {},
            };
            return acc;
          }, {}),
        },
        title: details?.content?.[currentLang]?.title || ""
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await taxonomyAddEdit({
        ...val,
        lang:userLang,
        slug:`${val?.content?.[currentLang]?.title.replace(/\s+/g, "-").toLowerCase()}-${Date.now()}`,
        type: type,
        content:val?.content,
        ...(data?._id && { id: data._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      if (res?.status === 200 || res?.status === 201) {
        resetField();
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="relative px-3 py-3">
      <Form onSubmit={onSubmit} handleSubmit={handleSubmit}>
        <LanguageTabs languages={supportedLanguages} value={currentLang} onChange={handleLangChange} />
        <div className="grid grid-cols-1 gap-3">
          <Input
            label={"Title"}
            inputType={"title"}
            inputPlaceholder="Enter title"
            inputName={"title"}
            value={values?.content?.[currentLang]?.title || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                 title: newValue,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    title: newValue,
                  },
                },
              });
            }}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="grid grid-cols-1 gap-3">
          <Textarea
            label={"Content"}
            inputPlaceholder={"Enter content"}
            inputName={`content`}
            inputValue={values?.content?.[currentLang]?.content || ""}

            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  contentValue:newValue,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    content: newValue,
                  },
                },
              });
            }}
          />
        </div>
        <div className="grid grid-cols-1 gap-3">
          <FlexibleSelect
            label={"Status"}
            placeholder={"Choose status"}
            onChange={(e) => handleChange({ target: { name: "status", value: e } })}
            selectedValue={values?.status}
            dropdownData={[
              { name: "Active", value: "active" },
              { name: "Inactive", value: "inactive" },
            ]}
          />
        </div>
        <div className="pt-3 pb-6 flex justify-end">
          <Button
            buttonType="submit"
            buttonClasses={"min-w-36"}
            buttonLabel={details?._id ? "Update" : "Save"}
            {...((isLoading || detailsLoading) && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
        </div>
      </Form>
    </div>
  );
};

export default TagManage;
